import { connect } from "react-redux";
import { withRouter } from "react-router";
import { ApplicationState } from "store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
    getCoverOptions,
    getCroppedCustomBackImage,
    getCroppedCustomImage,
    getOwnerPageImageOptions,
    getUploadedCoverImages,
} from "ui/store";
import {
    actionCreators as burdeApiContentActionCreators,
    getBurdeCoverSections,
} from "burde-api-content/store";
import { actionCreators, getCalendar } from "page/calendar/store";
import CoverControlsAccordion from "./cover-controls-accordion";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    Cover_Color: getResource(state, { key: "Cover_Color" }),
    Cover_Gallery: getResource(state, { key: "Cover_Gallery" }),
    Backpage_Color: getResource(state, { key: "Backpage_Color" }),
    Backpage_Gallery: getResource(state, { key: "Backpage_Gallery" }),
    Cover_Text_Tooltip: getResource(state, { key: "Cover_Text_Tooltip" }),
    Binding_Spiral: getResource(state, { key: "Binding_Spiral" }),
    Binding_Rubberband: getResource(state, { key: "Binding_Rubberband" }),
    NavControls_CoverPage: getResource(state, { key: "NavControls_CoverPage" }),
    NavControls_Binding: getResource(state, { key: "NavControls_Binding" }),
    Cover_Image_UploadError: getResource(state, {
        key: "Cover_Image_UploadError",
    }),
    Cover_Image_UploadErrorConfirm: getResource(state, {
        key: "Cover_Image_UploadErrorConfirm",
    }),
    calendar: getCalendar(state),
    activeComponent: getActiveNavigationComponent(state),
    coverOptions: getCoverOptions(state),
    ownerPageImageOptions: getOwnerPageImageOptions(state),
    burdeCoverSections: getBurdeCoverSections(state),
    croppedCustomCoverImage: getCroppedCustomImage(state),
    croppedCustomBackImage: getCroppedCustomBackImage(state),
    uploadedCoverImages: getUploadedCoverImages(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...burdeApiContentActionCreators,
};

const connectedComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CoverControlsAccordion);

export default withRouter(connectedComponent);
